import { render, staticRenderFns } from "./PendienteVsDespachado.vue?vue&type=template&id=dfc6ce90&scoped=true"
import script from "./PendienteVsDespachado.vue?vue&type=script&lang=js"
export * from "./PendienteVsDespachado.vue?vue&type=script&lang=js"
import style0 from "./PendienteVsDespachado.vue?vue&type=style&index=0&id=dfc6ce90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc6ce90",
  null
  
)

export default component.exports